import { useState,useEffect,useRef,useCallback } from "react";
import axios from "axios";
import { useMediaQuery, Grid2, Typography, Paper, InputBase, Divider, Box, Button } from "@mui/material"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { backendHosts,apiUrl } from "../../../ui-utils/apiConfig";
// import { useLanguage } from "../../../Context/LangContext";
function slugify(title) {
    return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "") // Remove special characters
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/-+/g, "-"); // Replace multiple hyphens with a single hyphen
  }


export default function BlogList({blogs}){


    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const navigate = useNavigate()
    // const handleTagClick = useCallback((tagName) => {
    //     setSelectedTag((prevTag) => {
    //         const newTag = prevTag === tagName ? null : tagName;
    //         setPage(1);
    //         return newTag;
    //     });
    // }, []);

    const handleCardClick = (blog) => {
        const slug = slugify(blog.blog_title);
        navigate(`/learn-research/blogs/${blog.id}-${slug}`);
        window.scrollTo(0, 0);
    };


    return(<main>
        <Grid2 container justifyContent="center" marginTop="42px" alignItems="center" paddingBottom="20px" position="relative" >
            <Grid2
                container
                spacing={4}
                sx={{ width: "90%", maxWidth: "1400px" }}
                justifyContent="center"
            >
                {blogs.map((blog) => {
                    const thumbnail = isSmallScreen
                        ? blog.blog_thumbnail_small_screen
                        : blog.blog_thumbnail_big_screen;

                    return (
                        <Grid2 item xs={12} sm={6} md={4} key={blog.id}>
                            <Box
                                onClick={() => handleCardClick(blog)}
                                sx={{
                                    height: "100%", // Allow the box to grow with content
                                    maxWidth: "414px",
                                    display: "flex",
                                    flexDirection: "column",
                                    cursor: "pointer",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                    overflow: "hidden",
                                    backgroundColor: "white",
                                    transition:
                                        "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0px 4px 62px 0px #00000040",
                                    },
                                    // "@media (max-width: 450px)": {
                                    //     width: "380px",
                                    // }

                                }}
                            >
                                {/* Image */}
                                <Box
                                    component="img"
                                    src={thumbnail}
                                    alt={blog.blog_title}
                                    sx={{
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                        transition:
                                            "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
                                    }}
                                />

                                {/* Content */}
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        textAlign: "left",
                                        padding:"5px 12px 0px 22px"
                                    }}
                                >
                                    {/* Tags */}
                                    <Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: 1,
                                                mb: 1,
                                            }}
                                        >
                                            {blog.blog_tags?.slice(0, 2).map((tag, index) => (
                                                <Typography
                                                    key={index}
                                                    sx={{
                                                        color: "#011126 !important",
                                                        fontSize: "calc(12px + var(--font-delta))",
                                                        lineHeight:"18px",
                                                        fontWeight: "bold",
                                                        fontFamily: "Inter600",
                                                        textTransform:"capitalize"
                                                    }}
                                                >
                                                    • {tag}
                                                </Typography>
                                            ))}
                                        </Box>

                                        {/* Title */}
                                        <Typography

                                            sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                fontWeight: "bold",
                                                fontSize: "calc(20px + var(--font-delta))",
                                                lineHeight: "28px",
                                                fontFamily: "Outfit400",
                                                color: "#011126",
                                                paddingLeft:"10px",
                                                textTransform: "capitalize",
                                                  "@media (max-width: 450px)": {
                                                      fontSize: "calc(18px + var(--font-delta))",
                                                }
                                            }}
                                        >
                                            {blog.blog_title}
                                        </Typography>

                                        {/* Description */}
                                        <Typography
                                            sx={{
                                                color: "#011126",
                                                fontSize: "calc(14px + var(--font-delta))",
                                                lineHeight: "21px",
                                                textAlign: "left",
                                                overflow: "hidden",
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 3,
                                                mt: 1,
                                                fontFamily: "Inter400",
                                                paddingLeft: "10px",
                                                textTransform: "capitalize",
                                                "@media (max-width: 450px)": {
                                                    fontSize: "calc(12px + var(--font-delta))",
                                                }
                                            }}
                                        >
                                            {blog.blog_description?.substring(0, 100)}...
                                        </Typography>
                                    </Box>

                                    {/* Footer */}
                                    <Grid2
                                        container
                                        alignItems="center"
                                        sx={{
                                            mt: 2,
                                        }}
                                    >
                                        {/* <Typography
                                                sx={{ textAlign: "left", fontFamily: "cardiuma-M" }}
                                            >
                                                10 Min read
                                            </Typography>
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{
                                                    mx: 1,
                                                    borderColor: "#999",
                                                    borderWidth: "1px",
                                                }}
                                            />
                                            <Typography
                                                sx={{ textAlign: "left", fontFamily: "cardiuma-M" }}
                                            >
                                                {formatDate(blog.created_at)}
                                            </Typography> */}
                                    </Grid2>
                                </Box>
                                <Box sx={{paddingLeft:"22px"}}>
                                    <Button
                                        onClick={() => handleCardClick(blog)}
                                        sx={{
                                            color: "#CB2F3F",
                                            fontWeight: "bold",
                                            display: "flex",
                                            alignItems: "center",
                                            fontFamily: "Inter400",
                                            fontSize: "calc(14px + var(--font-delta))",
                                            "&:hover": {
                                                backgroundColor: "transparent",
                                            },
                                              boxShadow: "none",

                                        }}
                                    >
                                        Read more
                                        <ArrowForwardIosIcon
                                            sx={{
                                                color: "#CB2F3F",
                                                borderRadius: "40%",
                                                background: "white",
                                                height: "15px",
                                                p: "10px",
                                                ml: "8px",
                                                width: "15px",
                                            }}
                                        />
                                    </Button>
                                </Box>
                            </Box>
                        </Grid2>
                    );
                })}
            </Grid2>
        </Grid2>
    </main>)
}